var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _vm.$userIsAdmin || _vm.$userIsManager
        ? _c("h2", [
            _vm._v("\n    " + _vm._s(_vm.$starLabel) + " List\n\n    "),
            _vm.userCanAddTalentResponses && _vm.$userIsAdmin
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-sm pull-right",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#modal-add-talent",
                      "data-backdrop": "static",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    [_vm._v("Add " + _vm._s(_vm.$starLabelPlural))],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userCanAddTalentResponses && _vm.$userIsManager
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-sm pull-right",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#modal-add-talent-manager",
                      "data-backdrop": "static",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    [_vm._v("Apply For " + _vm._s(_vm.$starLabelPlural))],
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _c("h2", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$starLabelPlural) +
                " who have responded to your " +
                _vm._s(_vm.$t("request")) +
                "\n  "
            ),
          ]),
      _vm._v(" "),
      _vm.haveNoTalentResponses
        ? _c(
            "div",
            { staticClass: "text-center alert alert-default" },
            [
              _vm.$userIsAdmin || _vm.$userIsManager
                ? [
                    _vm._v(
                      "\n      There are no " +
                        _vm._s(_vm.$starLabelPlural) +
                        " responses.\n    "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n      No " +
                        _vm._s(_vm.$starLabelPlural) +
                        " have responded yet.\n    "
                    ),
                  ],
            ],
            2
          )
        : _c(
            "ul",
            {
              staticClass: "item-detail item-detail-simple",
              class: {
                "item-detail-response": _vm.$userIsAdmin || _vm.$userIsManager,
                "item-detail-your-stars": _vm.$userIsClient,
              },
            },
            _vm._l(_vm.talentResponded, function (talent) {
              return !(
                talent.response.shortlisted === false &&
                talent.response.status === "declined" &&
                talent.response.decline_reason === "app"
              )
                ? _c("offer-booking-responses-list-item", {
                    key: talent.id,
                    attrs: { talent: talent, booking: _vm.booking },
                  })
                : _vm._e()
            }),
            1
          ),
      _vm._v(" "),
      _vm.totalPages > 1
        ? _c(
            "div",
            { staticClass: "flex flex-row page-buttons" },
            [
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { disabled: _vm.page === 1 },
                  on: { click: _vm.prevPage },
                },
                [_vm._v("Prev")]
              ),
              _vm._v(" "),
              _vm._l(_vm.totalPages, function (num) {
                return _c(
                  "button",
                  {
                    key: num,
                    staticClass: "btn",
                    class: { "btn-primary": num === _vm.page },
                    on: {
                      click: function ($event) {
                        return _vm.goToPage(num)
                      },
                    },
                  },
                  [_vm._v("\n      " + _vm._s(num) + "\n    ")]
                )
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { disabled: _vm.page === _vm.totalPages },
                  on: { click: _vm.nextPage },
                },
                [_vm._v("Next")]
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _vm.$userIsAdmin
        ? _c("offer-booking-add-talent-modal", { key: "1" })
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsManager
        ? _c("offer-booking-add-talent-modal-manager")
        : _vm._e(),
      _vm._v(" "),
      _c("booking-terms-and-conditions-modal", {
        ref: "terms",
        attrs: {
          booking: _vm.booking,
          talents: _vm.bookingAttendingTalent,
          "property-mutator": _vm.setRequestProperty,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }